import { ComponentRef, Injectable, OnDestroy } from '@angular/core';
import { GasDynamicComponentsService } from '@cikrf/gas-utils/services';

import { GasBaseModal } from './gas-base.modal';
import { GasModal } from './gas-modal.interface';
import { GasModalComponent } from './modal/gas-modal.component';

@Injectable({
  providedIn: 'root',
})
export class GasModalService<T> implements OnDestroy {
  public modals: GasModalComponent[] = [];

  private modalComponents: ComponentRef<GasModalComponent>[] = [];
  private dynamicComponents: ComponentRef<GasBaseModal<T>>[] = [];

  constructor(
    public gasDynamicComponentsService: GasDynamicComponentsService,
  ) { }

  /*
   * метод для создания модального окна
   * @param modal - объект с настройками модального окна
   * @param props? - параметры для работы в компоненте, который передается в body модального окна
   */
  public createModal<C>(modal: GasModal.Modal<C>, props?: Partial<T>): GasModalComponent {
    const modalComponent: ComponentRef<GasModalComponent> =
      this.gasDynamicComponentsService.createComponent<GasModalComponent>(GasModalComponent);

    let dynamicComponent: ComponentRef<GasBaseModal<T>>;

    //создаем компонент внутри модалки, если он был передан
    if (modal.component) {
      dynamicComponent = this.gasDynamicComponentsService.createComponent(modal.component as any, {
        viewContainer: modalComponent.instance.container,
      });

      dynamicComponent.instance.modal = modalComponent.instance;
      dynamicComponent.instance.props = props;

      this.dynamicComponents.push(dynamicComponent);
    }

    modalComponent.instance.modal = modal;
    modalComponent.instance.modal.component = dynamicComponent?.instance;

    this.modals.push(modalComponent.instance);
    this.modalComponents.push(modalComponent);

    return modalComponent.instance;
  }

  /** сохранение данных и закрытие модального окна */
  public saveAndClose<C>(data: C, modalId: string): void {
    const activeModal = this.modals.find((modal: GasModalComponent) => modal.id === modalId);

    activeModal.data$.next(data);

    this.closeModal(modalId);
  }

  /** закрытие модального окна */
  public closeModal(modalId: string): void {
    const activeModal = this.modals.find((modal: GasModalComponent) => modal.id === modalId);

    if (activeModal && typeof activeModal.modal.closeCallBack === 'function') {
      activeModal.modal.closeCallBack();
    }

    this.clearData(modalId);
  }

  /** удаляем все модалки и инстансы */
  public ngOnDestroy(): void {
    this.modalComponents.forEach((modal: ComponentRef<GasModalComponent>) => this.gasDynamicComponentsService.deleteComponent(modal));
    this.dynamicComponents.forEach((component: ComponentRef<GasBaseModal<T>>) =>
      this.gasDynamicComponentsService.deleteComponent(component));

    document.querySelectorAll('gas-modal').forEach((modal: HTMLElement) => modal.remove());
  }

  /** удаление динамичных элементов */
  private clearData(modalId: string): void {
    const dynamicComponent = this.dynamicComponents.find((component: ComponentRef<any>) =>
      component.instance.modal.id === modalId,
    );

    const modalComponent = this.modalComponents.find((component: ComponentRef<GasModalComponent>) =>
      component.instance.id === modalId,
    );

    if (dynamicComponent && modalComponent) {
      this.gasDynamicComponentsService.deleteComponent(modalComponent);
      this.gasDynamicComponentsService.deleteComponent(dynamicComponent);
    }

    this.modals = this.modals.filter((modal: GasModalComponent) => modal.id !== modalId);

    /** удаляем модальное окно из дом-дерева */
    document.querySelector(`gas-modal div#${modalId}`)?.parentElement.remove();
  }
}
